module.exports = __webpack_public_path__ + "static/media/icons-ic-cold-call-status.fe0de0da.svg";